import { render, staticRenderFns } from "./layout-detail.vue?vue&type=template&id=3d6e479d&scoped=true&"
import script from "./layout-detail.vue?vue&type=script&lang=js&"
export * from "./layout-detail.vue?vue&type=script&lang=js&"
import style0 from "./layout-detail.vue?vue&type=style&index=0&lang=less&"
import style1 from "./layout-detail.vue?vue&type=style&index=1&id=3d6e479d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6e479d",
  null
  
)

export default component.exports